/**
 * Finds positions for a specific word in the configuration
 * @param word Word to search for
 * @param config Array with letters of the configuration
 * @param options Options for the search
 * @returns Array with positions or null if not found
 */
const getPositionsForWord = (
  word: string,
  config: string[],
  options?: { preferFirst?: boolean }
): number[] | null => {
  // Optimization: Only calculate once and store as constant
  const joined = config.join('').toUpperCase();
  const wordUpper = word.toUpperCase();
  const matches: { positions: number[] }[] = [];

  // Find all occurrences of the word in the configuration
  for (let i = 0; i <= joined.length - wordUpper.length; i++) {
    if (joined.slice(i, i + wordUpper.length) === wordUpper) {
      // Create array with positions of individual letters
      matches.push({
        positions: Array.from({ length: wordUpper.length }, (_, j) => i + j),
      });
    }
  }

  if (matches.length === 0) return null;

  // Return either the first or last occurrence found
  return options?.preferFirst ? matches[0].positions : matches[matches.length - 1].positions;
};

/**
 * Finds all positions for a list of words in the configuration
 * @param words List of words to search for
 * @param config Array with letters of the configuration
 * @param options Options for the search
 * @returns Array with all found positions
 */
export const getPositions = (
  words: string[],
  config: string[],
  options?: { preferFirst?: boolean }
): number[] => words.flatMap(word => getPositionsForWord(word, config, options) ?? []);
